<template>
    <div>
        <div class="row card-body p-4">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3" style="margin: 0 auto;">
                <div  class="col select-Signature-Box "v-if="canUserSignWithDefaultSignature()" >
                    <div class="card shadow-sm" :disabled="!validForm"
                        @click="signDocument(singType.ByDefaultSignature)" >
                        <img src="/assets/images/icons/esignature.png" style="margin: 0 auto;margin-top: 30px"
                            alt="UAEPASS" class="signatureImage" />
                        <div class="card-body" style="text-align: center;">
                            <p class="card-text">{{ $t("res_label_sign_Signature_By_default_Signaute") }}</p>
                        </div>
                    </div>
                </div>
                <div class="col select-Signature-Box " v-if="canUserSignWithUAEPass() && enableUAEPassSignature">
                    <div class="card shadow-sm" @click="signDocumentWithUaePass">
                        <img src="/assets/images/icons/uaepass.png" style="margin: 0 auto;margin-top: 30px;"
                            alt="UAEPASS" class="signatureImage" />
                        <div class="card-body" style="text-align: center;">
                            <p class="card-text">{{ $t("res_label_sign_Signature_By_UAE-PASS") }}</p>
                        </div>
                    </div>
                </div>
                <div class="col select-Signature-Box " >
                    <div class=" elevation-3 rounded-12px pointer-cursor " @click="openAddSignatureDialog">
                        <div class="d-flex p-3 align-center gap-3 justify-center" style="text-align: center;">
                            <img src="/assets/images/icons/upload.png"  alt="upload"
                               max-width="60px" class="signatureImage" />
                          <span class="text-h6">
                            {{ $t("res_label_sign_Signature_By_Upload") }}
                          </span>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding-top: 15px;">
            <v-card-actions class="gap-2 sticky-actions">
                <v-spacer></v-spacer>
                <v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelDialog">Cancel</v-btn>
            </v-card-actions>
        </div>

        <v-dialog v-model="showAddSignatureDialog" width="35%" height="30%" @click:outside="closeAddSignatureDialog">
            <v-card>
                <v-card-title>
                    {{ $t("res_ModuleAction_document_SignDocument") }}
                </v-card-title>
                <v-divider class="m-0"></v-divider>
                <v-card-text>
                    <v-row class="my-3 ml-0">
                        <v-col cols="12" sm="6" v-if="signature_method == '1' && uploadedSignatureImage">
                            <img id="ItemPreview" class="border rounded shadow-sm"
                                style="object-fit:contain; width:175px; height: 100px;" ref="image"
                                :src=uploadedSignatureImage />
                        </v-col>
                        <v-col cols="12" sm="6" v-if="signature_method == '2' && drawedSignatureImage">
                            <img class="border rounded shadow-sm"
                                style="object-fit:contain; width:175px; height: 100px;" ref="image"
                                :src=drawedSignatureImage />
                        </v-col>
                    </v-row>
                    <v-row class=" ml-0">
                        <v-col>
                            <v-radio-group inline v-model="signature_method" row>
                                <div class="d-flex justify-center w-100">

                                    <v-radio color="#00ae8d" v-bind:label="$t('res_Radio_Image')" value="1"></v-radio>
                                    <v-radio color="#00ae8d" v-bind:label="$t('res_Radio_Draw')" value="2"></v-radio>
                                </div>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row class=" ml-0" v-show="signature_method == '1'">
                        <v-col>
                            <label>{{ $t("res_Label_AttachSignature") }} <span style="color: red"> *</span> </label>
                            <v-file-input id="input-file" accept="image/*" label="" solo
                            prepend-inner-icon="mdi-paperclip" prepend-icon=""
                                v-model="userSignature.signatureFile" @click="showTempCanvas = true"
                                @change="removeBackgroundColorOnAdd()" :rules="this.userSignature.uploadDocument">
                            </v-file-input>
                            <canvas id="signatureCanvas" v-if="showTempCanvas == true"></canvas>
                        </v-col>
                    </v-row>
                    <v-row class=" ml-0" v-show="signature_method == '2'">
                        <v-col id="signature_div">
                            <label>{{ $t("res_Label_DrawSignature") }} <span style="color: red"> *</span></label>

                            <VueSignaturePad id="signatureModel" width="100%" height="200px" ref="signaturePad"
                                :options="optionsPad" />

                            <vue-cropper class="cropper-SM " id="cropper-SM" ref="cropperSM" :img="option.img"
                                :output-size="option.size" :output-type="option.outputType" :info="true"
                                :full="option.full" :fixed="fixed" :fixed-number="fixedNumber"
                                :can-move="option.canMove" :can-move-box="option.canMoveBox"
                                :fixed-box="option.fixedBox" :auto-crop="option.autoCrop"
                                :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight"
                                :center-box="option.centerBox" @real-time="realTime" :high="option.high"
                                @img-load="imgLoad" mode="cover" :max-img-size="option.max"
                                @crop-moving="cropMoving"></vue-cropper>

                            <div>
                                <img id='image-to-crop-SM' />
                            </div>

                            <v-spacer></v-spacer>
                            <v-btn width="100" id="crop-btn-SM" class="primary white--text mt-4"
                                @click="convertToImage()">{{
                                    $t("res_ButtonText_Crop") }}</v-btn>
                            <v-btn width="100" id="done-btn-SM" class="primary white--text mt-4 " @click="finish2()">{{
                                $t("res_ButtonText_Done") }}</v-btn>
                            <v-btn width="100" id="clear-btn-SM" class="primary white--text mt-4 ml-4 "
                                @click="resetCanvas()">{{ $t("res_ButtonText_Clear") }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn width="100" class="primary white--text" @click="addUserSignature()">{{
                        $t("res_ButtonText_Submit") }}</v-btn>

                    <v-btn color="light-blue" width="100" @click="closeAddSignatureDialog()">{{
                        $t("res_ButtonText_Cancel")
                        }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import constants from '@/assets/js/constants'
import { singType } from '@/assets/js/enums.js'
import axios from 'axios'
import MultiSelect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'Sign',
    data() {
        return {
            enableUAEPassUserSignatureImage: window.enableUAEPassUserSignatureImage,
            enableUAEPassSignature:window.enableUAEPassSignature,
            pinValue: '',
            validForm: false,
            showEsignature: true,
            subject: "",
            singType: singType,
            showAddSignatureDialog: false,
            uploadedSignatureImage: '',
            drawedSignatureImage: '',
            userSignature: {
                selectedSignatures: [],
                signatureFile: {},
                drawingSigntureFile: {},
                uploadDocument: [value => !!value || 'Please upload signature'],
            },
            showTempCanvas: true,
            signatureWidth: 0,
            signatureHeight: 0,
            showResizeSignatureSkeleton: true,
            edit_image: '',
            signature_method: '1',
            current_action: 'new',
            optionsPad: {
                dotSize: (0.5 + 2.5) / 2,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16,
                minDistance: 5,
                backgroundColor: 'rgba(0,0,0,0)',
                penColor: 'black',
                velocityFilterWeight: 0.7,
                onBegin: () => {
                    if (this.$refs.signaturePad)
                        this.$refs.signaturePad.resizeCanvas()
                },
                onEnd: () => { }
            },
            model: false,
            modelSrc: '',
            crap: false,
            previews: {},
            imageFile: null,
            lists: [{ img: '' }],
            option: {
                img: '',
                size: 1,
                full: false,
                outputType: 'png',
                canMove: true,
                fixedBox: false,
                original: false,
                canMoveBox: true,
                autoCrop: true,
                autoCropWidth: 750,
                autoCropHeight: 340,
                centerBox: true,
                high: true,
                max: 99999
            },
            show: true,
            fixed: false,
            fixedNumber: [16, 9],
            loading: false,
            options: ['list', 'of', 'options'],
            resizeSignature: { id: 0, width: 0, height: 0, signature: '', maintainAspectRatio: true, originalWidth: 0, originalHeight: 0 },
            resizeSignatureDialog: false,
            aspectRatioSynchronizing: false,
            client_version_Id: constants.client_version_Id,
            tempSignature: null,
            messagesUtil: window.MessagesUtil,
            isEsealEnabledForTemplate: false,
            lang: "",
        };
    },
    props: {
        dialogModelShow: { type: Boolean, default: false },
        propertyBag: { type: Object },
    },
    methods:
    {
        canUserSignWithUAEPass(){
            if(window.enableUAEPassUserSignatureImage){
              return   true;
            }else if(this.propertyBag.isUserDefaultSignatureAvailable){
                return   true;
            }
            return   false;
        },
        canUserSignWithDefaultSignature(){
            if(this.propertyBag.isUserDefaultSignatureAvailable){
                return   true;
            }
            return   false;
        },
        getPermissionToSign() {
            // window.showLoading()
            // axios.get(constants.baseApiUrl + 'Document/CheckHasValidSignature?delegationId=' + this.propertyBag.delegationId)
            //     .then(res => {
            //         if (res.data == 'SignaturePinNotSet')
            //             window.showAlert('You have not set a signature pin. Please set a signature pin in your profile', 'warning')

            //         else if (res.data == 'NoDefaultSignatureFound')
            //             window.showAlert('You don\'t have a default signature. Please add a signature and set it to default', 'warning')

            //         else
            //             this.validForm = true
            //     })
            //     .catch(err => window.showAlert(err, 'error'))
            //     .finally(() => window.hideLoading())
        },

        signDocument(singType, sBytes = null) {
            window.showInformation(
                this.$t("res_Label_Alert"),
                this.$t("res_label_sign_with_Default_confirm"),
                () => {
                    this.signDocumentAPI(singType, sBytes)
                },
                () => { }
            );

        },
        signDocumentAPI(singType, sBytes = null) {
            window.showLoading()
            const documentIds = this.propertyBag.documentId;
            this.isLoading = true;
            const formData = {
                DocumentIds: JSON.stringify(documentIds),
                SignatureBytes: sBytes,
                SignType: singType
            };

            axios.post(constants.baseApiUrl + 'Document/SignDocument', formData)
                .then(res => {
                    var response = res.data;
                    if (response && response.data != null && res.data.success) {
                        debugger
                        response.data.forEach((msg) => {
                            if (msg === "signCompleted") {  // Correct way to check for "signCompleted"
                                window.showAlert(this.$t('res_Msgs_SignedSuccess'), 'success');
                                this.$emit('refreshAfterClosingSignMethodSelect');
                            }
                            else if (msg.startsWith("cannotSign:")) {  // Correct way to check for "cannotSign"
                                let errorCode = msg.replace("cannotSign:", '');
                                window.showAlert(this.$t('res_Msg_PermissionToSignDocument') + ": " + errorCode, 'warning');
                            }
                            else {
                                window.showAlert(msg, 'warning', 5000);
                            }
                        });
                    }
                    else
                        window.showAlert('res_Msgs_ErrorOccured', 'error')
                })
                .catch(error => { window.showAlert('res_Msgs_ErrorOccured', 'error') })
                .finally(() => { this.isLoading = false; window.hideLoading() })
        },
        addUserSignature() {
            if (this.signature_method == '2') {
                var isCropping = this.$refs.cropperSM.cropping
                if (!isCropping)
                    this.userSignature.signatureFile = {};

                var isEmpty = this.$refs.signaturePad.signaturePad._isEmpty;
                if (isEmpty) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }
                if (!this.userSignature.signatureFile.size)
                    this.convertToImage();

                this.readFile(this.userSignature.drawingSigntureFile, (fileBytes) => {
                    const SignatureBytes = this.bytesToBase64(fileBytes);

                    this.showAddSignatureDialog = false;
                    this.userSignature.signatureFile = {};
                    this.userSignature.drawingSigntureFile = {};
                    this.$refs.cropperSM.cropping = false;
                    this.drawedSignatureImage = '';
                    this.uploadedSignatureImage = '';


                    if (SignatureBytes != null) {
                        this.showAddSignatureDialog = false;
                        this.signDocumentAPI(singType.BySignaturePad, SignatureBytes);
                    } else {
                        window.showAlert('res_Msgs_ErrorOccured', 'error');
                    }

                });

            } else {

                if (!this.userSignature.signatureFile.size) {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), "warning");
                    return;
                }
                if (this.userSignature.signatureFile.size > 1000000) {
                    window.showAlert("res_validation_ImageSize", 'warning');
                    return;
                }

                this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                    const SignatureBytes = this.bytesToBase64(fileBytes);

                    this.showAddSignatureDialog = false;
                    this.userSignature.signatureFile = {};
                    this.userSignature.drawingSigntureFile = {};
                    this.$refs.cropperSM.cropping = false;
                    this.drawedSignatureImage = '';
                    this.uploadedSignatureImage = '';

                    if (SignatureBytes != null) {
                        this.showAddSignatureDialog = false;
                        this.signDocumentAPI(singType.ByUploadFile, SignatureBytes);
                    } else {
                        window.showAlert('res_Msgs_ErrorOccured', 'error');
                    }

                });
            }
        },
        signDocumentWithUaePass() {

            window.showLoading();
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/SignUAEPassDocuments?documentId=' + this.propertyBag.documentId)
                .then(respose => {
                    if (respose.data != null && respose.data.success) {
                        var res = respose.data;
                        this.lang = 'en'
                        let token = localStorage.getItem('user');
                        let documentId = this.propertyBag.documentId;
                        var w = 720;
                        var h = 530;
                        var title = '_blank'
                        var left = (screen.width / 2) - (w / 2);
                        var top = (screen.height / 2) - (h / 2);

                        // window.close();
                        var ltvEnabled = true;
                        if (constants.ltvEnabled !== undefined) {
                            ltvEnabled = constants.ltvEnabled;
                        }
                        var Url = baseUrl + 'UAEPass?id=' + documentId + '&storageAttachmentId=' + 0 + '&x=' + res.data.uaePassESealStampPosition.x + '&y=' + res.data.uaePassESealStampPosition.y + '&stampX=' + res.data.uaePassSignaturePosition.x + '&stampY=' + res.data.uaePassSignaturePosition.y + '&ltvEnabled=' + ltvEnabled + '&esealEnabled=' + this.isEsealEnabledForTemplate + "&lang=" + this.lang + '&token=' + token, title;
                        var windowObjectReference = window.open(baseUrl + 'UAEPass?id=' + documentId + '&storageAttachmentId=' + 0 + '&x=' + res.data.uaePassESealStampPosition.x + '&y=' + res.data.uaePassESealStampPosition.y + '&stampX=' + res.data.uaePassSignaturePosition.x + '&stampY=' + res.data.uaePassSignaturePosition.y + '&ltvEnabled=' + ltvEnabled + '&esealEnabled=' + this.isEsealEnabledForTemplate + "&lang=" + this.lang + '&token=' + token, title);

                        const checkStatus = () => {
                            this.checkUAEPassSignStatus(interval, windowObjectReference, baseUrl);
                        }

                        const interval = setInterval(() => {
                            checkStatus();
                        }, 2000);
                    } else {
                        window.hideLoading()
                        window.showAlert(this.$t(respose.message), 'error');
                    }
                })
                .catch(error => console.log(error), window.hideLoading())
        },
        signDocumentWithDocusign() {

            window.showLoading();
            let baseUrl = constants.baseApiUrl;
            axios.post(baseUrl + 'Document/PrepareDocumentForDocuSign?documentId=' + this.propertyBag.documentId + '&delegationId=' + this.propertyBag.delegationId)
                .then(res => {
                    let token = localStorage.getItem('user');
                    var windowObjectReference = window.open(res.data.item2, "Sign With Docusign", '_blank');
                    var envelopeId = res.data.item1;
                    window.hideLoading();
                    console.log('data', res)
                })
                .catch(error => console.log(error))
        },
        checkUAEPassSignStatus(interval, popup, baseUrl) {

            if (popup.closed == true) {
                window.hideLoading()
            }
            else {
                let token = localStorage.getItem('user');
                let documentId = this.propertyBag.documentId;

                const headers = {
                    'Authorization': 'Bearer ' + localStorage.getItem('user')
                };


                axios.get(baseUrl + 'UAEPass/SigningStatus?DocumentId=' + documentId + '&token=' + token, headers)
                    .then(res => {
                        if (res.data == "" || res.data == undefined || res.data == null)
                            return;

                        if (res.data == "finished") {
                            window.showAlert('Successfully Signed', 'success')
                            axios.post(baseUrl + 'Document/MarkDocumentSigned?documentId=' + this.propertyBag.documentId + '&delegationId=' + this.propertyBag.delegationId)
                                .then(res => {
                                    window.hideLoading();
                                    console.log('uae cleared = ', res)
                                }
                                )
                        }
                        else {
                            window.showAlert('Something went wrong', 'warning')
                            window.hideLoading();
                        }
                        clearInterval(interval);
                        popup.close();

                        this.$emit('refreshAfterClosingSignMethodSelect');
                    })
                    .catch(err => window.showAlert(err, 'error'))

            }
        },
        cancelDialog() {
            this.$emit('closeSelectSignMethodFormDialog');
        },
        resetForm() {
            this.pinValue = ''
            this.validForm = false
        },
        openAddSignatureDialog() {
            this.current_action = 'new';
            this.showAddSignatureDialog = true;
        },
        resetCanvas() {
            this.undo();
        },
        closeAddSignatureDialog() {
            this.showAddSignatureDialog = false;
            this.drawedSignatureImage = '';
            this.uploadedSignatureImage = '';
        },

        async fetchOriginalWidth_Height(file) {
            return new Promise((resolve, reject) => {
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.src = e.target.result;
                        img.onload = () => {
                            const width = img.width;
                            const height = img.height;
                            resolve({ "width": width, "height": height });
                        };
                    };
                    reader.readAsDataURL(file);
                } else {
                    reject("File not provided");
                }
            });
        },
        async removeBackgroundColorOnAdd() {
            let MainImage = await this.fetchOriginalWidth_Height(this.userSignature.signatureFile);
            if (this.userSignature.signatureFile && this.userSignature.signatureFile != null && this.userSignature.signatureFile != undefined) {
                this.readFile(this.userSignature.signatureFile, (fileBytes) => {
                    window.showLoading();
                    var array = fileBytes,
                        imgData = fileBytes;
                    const canvas = document.getElementById('signatureCanvas');
                    canvas.width = MainImage.width;
                    canvas.height = MainImage.height;
                    //draw image
                    var ctx = canvas.getContext("2d");
                    var uInt8Array = imgData;
                    var i = uInt8Array.length;
                    var binaryString = [i];
                    while (i--) {
                        binaryString[i] = String.fromCharCode(uInt8Array[i]);
                    }
                    var data = binaryString.join('');
                    var base64 = window.btoa(data);
                    var img = new Image();
                    img.src = "data:image/png;base64," + base64;
                    this.uploadedSignatureImage = img.src;
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height),
                            pix = imgd.data,
                            newColor = { r: 0, g: 0, b: 0, a: 0 };
                        for (var i = 0, n = pix.length; i < n; i += 4) {
                            var r = pix[i],
                                g = pix[i + 1],
                                b = pix[i + 2];
                            if (r == 255 && g == 255 && b == 255) {
                                // Change the white to the new color.
                                pix[i] = newColor.r;
                                pix[i + 1] = newColor.g;
                                pix[i + 2] = newColor.b;
                                pix[i + 3] = newColor.a;
                            }
                        }
                        ctx.putImageData(imgd, 0, 0);
                        const image = new Image();
                        image.src = canvas.toDataURL();
                        this.ConvertClick(image.src);
                        canvas.style.height = "0px";
                        window.hideLoading()
                    };
                })
            }
        },
        removeImageWhiteBg() {
            const canvasDiv = document.getElementById('signatureModel')
            const canvas = canvasDiv.getElementsByTagName('canvas')[0];
            const ctx = canvas.getContext('2d');
            var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height), pix = imgd.data, newColor = { r: 0, g: 0, b: 0, a: 0 };
            for (var i = 0, n = pix.length; i < n; i += 4) {
                var r = pix[i], g = pix[i + 1], b = pix[i + 2];
                if (r == 255 && g == 255 && b == 255) {
                    // Change the white to the new color.
                    pix[i] = newColor.r;
                    pix[i + 1] = newColor.g;
                    pix[i + 2] = newColor.b;
                    pix[i + 3] = newColor.a;
                }
            }
            ctx.putImageData(imgd, 0, 0);
        },
        startCrop() {
            this.crap = true
            this.$refs.cropperSM.startCrop()
        },
        stopCrop() {
            this.crap = false
            this.$refs.cropperSM.stopCrop()
        },
        clearCrop() {
            this.$refs.cropperSM.clearCrop()
        },
        refreshCrop() {
            this.$refs.cropperSM.refresh()
        },
        changeScale(num) {
            num = num || 1
            this.$refs.cropperSM.changeScale(num)
        },
        rotateLeft() {
            this.$refs.cropperSM.rotateLeft()
        },
        rotateRight() {
            this.$refs.cropperSM.rotateRight()
        },
        realTime(data) {
            this.previews = data;
        },
        finish2(type) {
            this.$refs.cropperSM.getCropData((data) => {
                var itc = document.getElementById('image-to-crop-SM')
                itc.src = data
                this.drawedSignatureImage = data;
                itc.style.display = 'block'
                var cr = document.getElementById('cropper-SM')
                cr.style.display = 'none'
                var doneBtn = document.getElementById('done-btn-SM')
                doneBtn.style.display = 'none'
                this.ConvertClick(data);
            })
        },
        imgLoad(msg) {
        },
        cropMoving(data) {
        },
        convertToImage() {
            this.removeImageWhiteBg();
            // Get the canvas element
            const canvasDiv = document.getElementById('signatureModel')
            const canvas = canvasDiv.getElementsByTagName('canvas')[0];
            const context = canvas.getContext('2d');
            // Create an image element
            const image = new Image();
            // Assign the canvas content as the source of the image
            image.src = canvas.toDataURL();
            const imageObject = document.getElementById('image-to-crop-SM')
            const doneBtn = document.getElementById('done-btn-SM')
            const cropBtn = document.getElementById('crop-btn-SM')
            const clearBtn = document.getElementById('clear-btn-SM')
            const cropper = document.getElementById('cropper-SM')
            cropper.style.display = "block";
            cropBtn.style.display = "none";
            canvasDiv.style.display = "none";
            clearBtn.style.display = "none";
            doneBtn.style.display = "block";
            imageObject.src = '';
            this.option.img = image.src;
            this.drawedSignatureImage = image.src;
            this.ConvertClick(image.src);
        },
        undo() {
            this.$refs.signaturePad.fromData([]);
            this.drawedSignatureImage = '';
        },
        save() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        },
        change() {
            this.options = { penColor: "#00f" };
        },
        resume() {
            this.options = { penColor: "#c0f" };
        },
        backToAdminPage() {
            router.push({ name: 'admin' })
        },
        clearFields() {
            this.search_query = ''
            this.companyId = {}
        },
        manageUserSignatures(id) {
            this.userId = id;
        },
        resetCanvas() {
            this.undo();
        },
        bytesToBase64(signatureBytes) {
            let binary = '';
            let len = signatureBytes.length;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(signatureBytes[i]);
            }

            return window.btoa(binary);
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        ConvertClick(base64url) {
            var extension = new Date().getTime();
            var file = this.dataURLtoFile(base64url, String("signature" + extension + ".png"));
            let container = new DataTransfer();
            container.items.add(file);
            var input = document.createElement('input');
            input.type = "file";
            input.id = 'input-file'
            input.files = container.files;
            var newfile = input.files[0];

            this.userSignature.drawingSigntureFile = newfile;

            this.imageFile = this.base64ToArrayBuffer(base64url.split('data:image/png;base64,')[1]);
            return file;
        },
        base64ToArrayBuffer(base64) {
            var binaryString = atob(base64);
            var bytes = new Uint8Array(binaryString.length);
            for (var i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        },

        async readFile(file, successHandler) {
            var reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState === FileReader.DONE) {
                    var arrayBuffer = evt.target.result;
                    var fileByteArray = new Uint8Array(arrayBuffer); // Direct assignment
                    successHandler(fileByteArray);
                }
            };
        },
        updateResizeSignatureWidth() {
            if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) {
                this.aspectRatioSynchronizing = true;
                this.resizeSignature.width = Math.round((this.signatureWidth * this.resizeSignature.height) / this.signatureHeight);
                this.aspectRatioSynchronizing = false;
            }
        },
        updateResizeSignatureHeight() {
            if (this.resizeSignature.maintainAspectRatio && this.aspectRatioSynchronizing == false) {
                this.aspectRatioSynchronizing = true;
                this.resizeSignature.height = Math.round((this.signatureHeight * this.resizeSignature.width) / this.signatureWidth);
                this.aspectRatioSynchronizing = false;
            }
        },
    },
    watch:
    {
        signature_method(newValue, oldValue) {
            if (newValue == '2' && this.current_action == 'edit') {
                setTimeout(() => {
                    this.$refs.signaturePad.resizeCanvas();
                }, "1000")
            }
        },
        dialogModelShow(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == true)
                    this.getPermissionToSign()
                else
                    this.resetForm()
            }
        },
        showAddSignatureDialog(newValue, oldValue) {
            if (newValue == false) {
                var imgtocrop1 = document.getElementById('image-to-crop-SM');
                var signatureModel = document.getElementById('signatureModel');
                var cropperSM = document.getElementById('cropper-SM');
                const cropBtn = document.getElementById('crop-btn-SM')
                const clearBtn = document.getElementById('clear-btn-SM')
                const doneBtn = document.getElementById('done-btn-SM');
                imgtocrop1.style.display = 'none';
                signatureModel.style.display = 'block';
                this.userSignature.signatureFile = {};
                if (cropperSM && cropperSM.style.display == 'block') {
                    cropperSM.style.display = 'none';
                }
                if (cropBtn && cropBtn.style.display == 'none') {
                    cropBtn.style.display = 'inline';
                }
                if (clearBtn && clearBtn.style.display == 'none') {
                    clearBtn.style.display = 'inline';
                }
                if (doneBtn && doneBtn.style.display == 'block') {
                    doneBtn.style.display = 'none';
                }
                this.resetCanvas(); this.signature_method = "1";
            }
        },
    },
    mounted: function () {
        // this.getPermissionToSign()
    },
    filters:
    {
        limitText(text, maxSize) {
            if (!text) return '';
            text = text.toString();

            if (text.length <= maxSize) {
                return text;
            }

            return text.substr(0, maxSize).trim() + ' ...';
        }
    },
}
</script>

<style>
.ResizeElements .v-skeleton-loader__text {
    height: 35px !important;
}

.ResizeImage .v-skeleton-loader__text {
    width: 600px;
    margin: auto;
    height: 200px !important;
}
</style>

<style scoped>
#signatureModel {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
    touch-action: auto !important;
}

#signatureModel2 {
    border: double 3px transparent;
    border-radius: 5px;
    background-image: linear-gradient(white, white),
        radial-gradient(circle at top left, #4bc5e8, #9f6274);
    background-origin: border-box;
    background-clip: content-box, border-box;
    touch-action: auto !important;
}

#done-btn-SM {
    display: none;
}

#done-btn-SM2 {
    display: none;
}

.cropper-SM {
    display: none;
    height: 200px !important;
}

.cropper-SM2 {
    display: none;
    height: 200px !important;
}

.container {
    width: "100%";
    padding: 8px 16px;
}

.buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 8px;
}

.vtooltip {
    background-color: white;
    padding: 5px;
    border-radius: 25px;
}

.report-container .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.report_header {
    height: 50px;
    vertical-align: middle;
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.015em;
    color: #667593;
}

.report-container .theme--light.v-data-table.v-data-table--fixed-header thead th,
.report-container .v-data-table__wrapper table thead {
    background-color: #FFF;
    box-shadow: none;
}

.report-container {
    height: calc(100vh - 116px);
    display: flex;
    flex-direction: column;
    border-radius: 12px !important;
    overflow: auto;
    box-shadow: none !important;
}

.report-container .border-top {
    display: flex;
    flex-direction: column;
}

.report-container .v-toolbar {
    height: 80px !important;
    padding: 0;
}

.report-container .v-toolbar__content {
    height: 100% !important;
    padding: 24px !important;
}

img#ItemPreview {
    width: 100px;
    margin: 0.5rem 0;
}

.mdi-menu-down {
    filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(232%) hue-rotate(182deg) brightness(102%) contrast(83%) !important;
}

.v-dialog .v-toolbar__content {
    height: 100% !IMPORTANT;
}

.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
}

#image-to-crop-SM {
    width: 100%;
    height: auto !important
}

#image-to-crop-SM2 {
    width: 100%;
    height: auto !important
}

#cropper-SM {
    width: 100%;
    height: 200px !important
}

#cropper-SM2 {
    width: 100%;
    height: 200px !important
}

#signatureModel2 {
    height: 200px !important;
}

#signatureModel {
    height: 200px !important;
}

#signatureCanvas {
    width: 100% !important;
    height: 0px;
}
.signatureImage{
    width: 60px !important;
}
</style>